// extracted by mini-css-extract-plugin
export default {"backdrop":"backdrop--PpjF0","modal":"modal--lD4_e","js-has-pseudo":"js-has-pseudo--TEdk5"};